'use es6';

import * as checked from 'reporting-data/lib/checked';
import { CROSS_TAB, DATAWELL, GAUGE, SLICED, TABLE, XY } from 'reporting-visualizations/constants/visualizationTypes';
import { Events as CrossTabEvents } from 'reporting-visualizations/visualizations/crossTab/crossTabRecords';
import { Events as DataWellEvents } from 'reporting-visualizations/visualizations/datawell/datawellRecords';
import { Events as SlicedEvents } from 'reporting-visualizations/visualizations/sliced/slicedRecords';
import { Events as TableEvents } from 'reporting-visualizations/visualizations/table/tableRecords';
import { Events as XYEvents } from 'reporting-visualizations/visualizations/xy/xyRecords';
import { Events as GaugeEvents } from 'reporting-visualizations/visualizations/gauge/GaugeRecords';
import { getColumn } from '../utils/column-utils';
const NormalizedEvent = checked.record({
  row: checked.any(),
  field: checked.string().optional(),
  levelOfDetail: checked.list(checked.string()).optional()
});
const typeToPointClickEventNormalizer = {
  [XY]: clickEvent => NormalizedEvent({
    row: clickEvent.point.get('row'),
    levelOfDetail: clickEvent.levelOfDetail
  }),
  [SLICED]: clickEvent => NormalizedEvent({
    row: clickEvent.point.get('sliceRow')
  }),
  [DATAWELL]: clickEvent => NormalizedEvent({
    row: clickEvent.row,
    field: clickEvent.field
  }),
  [TABLE]: clickEvent => NormalizedEvent({
    row: clickEvent.row,
    field: clickEvent.field
  }),
  [CROSS_TAB]: clickEvent => NormalizedEvent({
    row: clickEvent.row,
    field: clickEvent.field,
    levelOfDetail: clickEvent.levelOfDetail
  })
};
const columnHasAggregation = (columns, columnId) => {
  const column = getColumn(columns, columnId);
  return !!column.aggregation;
};
export const withEvents = (events, visualization, columns) => {
  const {
    type
  } = visualization;
  const normalizedEvents = events.update('onPointClick', maybeHandler => {
    if (maybeHandler == null) {
      return maybeHandler;
    }
    const maybeNormalizer = typeToPointClickEventNormalizer[type];
    const decorateWithProcessor = (processEvent, baseHandler) => e => baseHandler(processEvent(e));
    return maybeNormalizer ? decorateWithProcessor(maybeNormalizer, maybeHandler) : maybeHandler;
  });
  const normalizedOnPointClick = normalizedEvents.get('onPointClick');
  let eventsRecord;
  const normalizedOnSort = normalizedEvents.get('onSort');
  switch (type) {
    case XY:
      eventsRecord = XYEvents({
        onPointClick: normalizedOnPointClick
      });
      break;
    case SLICED:
      eventsRecord = SlicedEvents({
        onPointClick: normalizedOnPointClick
      });
      break;
    case DATAWELL:
      eventsRecord = DataWellEvents({
        getOnPointClick: () => normalizedOnPointClick
      });
      break;
    case TABLE:
      eventsRecord = TableEvents({
        getOnPointClick: ({
          field: columnId
        }) => {
          const isAggregated = columnHasAggregation(columns, columnId);
          return isAggregated ? normalizedOnPointClick : undefined;
        }
      });
      if (normalizedOnSort) {
        visualization = visualization.update('columns', vizColumns => vizColumns = vizColumns.map(column => column = column.set('onSort', normalizedOnSort)));
      }
      break;
    case CROSS_TAB:
      eventsRecord = CrossTabEvents({
        onClick: normalizedOnPointClick
      });
      break;
    case GAUGE:
      eventsRecord = GaugeEvents({
        onPointClick: normalizedOnPointClick
      });
      break;
    default:
      eventsRecord = undefined;
      break;
  }
  return eventsRecord ? visualization.set('events', eventsRecord) : visualization;
};